import PropTypes from 'prop-types';
import { Button } from '@mui/material';

/** @component
 * Creates a Go Pro button for upgrading to Insight Pro
 *
 * @component
 * @param {Function} onClick - Function to call when button clicked.
 * @returns {React.Element} The Go Pro button
 */
export const GoProButton = ({ onClick, sxProps }) => {
    return (
        <Button
            id={'goProButton'}
            variant='minorContained'
            onClick={onClick}
            sx={{
                textWrap: 'nowrap',
                ...sxProps
            }}
            data-analyticsid='go-pro-button'
        >
            Go Pro
        </Button>
    );
};

GoProButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    sxProps: PropTypes.object
};
